@if (config) {
    <main
        class="agpr-hypePage"
        [ngClass]="config.class"
    >
        @if (config.naturalLanguage && !config.isNotFound) {
            <div class="agpr-hypePage-content">
                @if (!!config.icon) {
                    <div
                        class="agpr-hypePage-logo"
                        [ngClass]="config.icon"
                        aria-hidden="true"
                    ></div>
                }
                @if (!!config.iconUrl) {
                    <div>
                        <img
                            [src]="config.iconUrl"
                            alt=""
                            aria-hidden="true"
                        >
                    </div>
                }
                <div class="agpr-hypePage-headerTitle">
                    {{ config.headingText | localize }}
                </div>
                @if(!!config.line1Text) {
                    <div class="agpr-hypePage-text">
                        {{ config.line1Text | localize }}
                    </div>
                }
                @if(!!config.line1Html) {
                    <div
                        class="agpr-hypePage-text"
                        [innerHTML]="config.line1Html"
                    >
                    </div>
                }

                @if (config.naturalLanguageTabLabel && config.secondaryHeadingText) {
                    <!-- Tab toggle: shown when both a primary tab label and a secondary tab are configured -->
                    @if(!!config.line2Text) {
                        <div
                            class="agpr-hypePage-text line2"
                            [ngClass]="{ 'agpr-hypePage-text--bold': config.line2Bold }"
                        >
                            {{ config.line2Text | localize }}
                        </div>
                    }
                    <div
                        class="agpr-hypePage-tabPanel"
                        [ngClass]="selectedTabType === hypeTabTypeEnum.primary ? 'agpr-hypePage-tabPanel--primary' : 'agpr-hypePage-tabPanel--secondary'"
                    >
                        <div
                            class="agpr-hypePage-tabToggle"
                            [ngClass]="{ 'agpr-hypePage-tabToggle--withBottomMargin': selectedTabType === hypeTabTypeEnum.secondary }"
                            role="tablist"
                            tabindex="0"
                            (keydown)="onTabToggleKeydown($event)"
                        >
                            <agpr-button
                                id="agpr_hype_tabToggle_primary"
                                class="agpr-hypePage-tabToggle-option"
                                [ngClass]="{'agpr-hypePage-tabToggle-option--selected': selectedTabType === hypeTabTypeEnum.primary}"
                                [style]="buttonTypes.secondary"
                                [label]="config.naturalLanguageTabLabel"
                                [icon]="config.naturalLanguageTabIcon"
                                [active]="selectedTabType === hypeTabTypeEnum.primary"
                                [role]="'tab'"
                                [ariaSelected]="selectedTabType === hypeTabTypeEnum.primary"
                                (click)="selectedTabType = hypeTabTypeEnum.primary"
                                tabindex="-1"
                            ></agpr-button>
                            <agpr-button
                                id="agpr_hype_tabToggle_secondary"
                                class="agpr-hypePage-tabToggle-option"
                                [ngClass]="{'agpr-hypePage-tabToggle-option--selected': selectedTabType === hypeTabTypeEnum.secondary}"
                                [style]="buttonTypes.secondary"
                                [label]="config.secondaryHeadingText"
                                [icon]="config.secondaryIcon"
                                [active]="selectedTabType === hypeTabTypeEnum.secondary"
                                [role]="'tab'"
                                [ariaSelected]="selectedTabType === hypeTabTypeEnum.secondary"
                                (click)="selectedTabType = hypeTabTypeEnum.secondary"
                                tabindex="-1"
                            ></agpr-button>
                        </div>

                        @if (selectedTabType === hypeTabTypeEnum.primary) {
                            <agpr-agent-banner
                                class="agpr-hypePage-agentBanner agpr-hypePage-agentBanner--tabPanel"
                                [id]="id"
                                [headerTitle]="config?.naturalLanguageBannerTitle | localize"
                                [placeholder]="config?.naturalLanguagePlaceholder | localize"
                                [submitTooltip]="config?.naturalLanguageSubmitTooltip"
                                [submitTooltipEmpty]="config?.naturalLanguageSubmitTooltipEmpty"
                                [showExpandButton]="false"
                                [hasAgentDebug]="hasAgentDebug"
                                [(naturalLanguagePrompt)]="naturalLanguagePrompt"
                                [(taskDescription)]="taskDescription"
                                [(systemPrompt)]="systemPrompt"
                                [(topicSystemPrompt)]="topicSystemPrompt"
                                (submit)="showContextTakeover($event)"
                            ></agpr-agent-banner>
                        }

                        @if (selectedTabType === hypeTabTypeEnum.secondary) {
                            <div class="agpr-hypePage-tabSecondaryPanel">
                                @if (config.secondaryLineText) {
                                    <p class="agpr-hypePage-tabSecondaryPanel-description">
                                        {{ config.secondaryLineText | localize }}
                                    </p>
                                }
                                @if (config.secondaryLinkText) {
                                    <agpr-button
                                        id="agpr_hype_tabToggle_secondaryLink"
                                        [label]="config.secondaryLinkText"
                                        [style]="buttonTypes.primary"
                                        (click)="clickSecondaryLink()"
                                    ></agpr-button>
                                }
                            </div>
                        }
                    </div>
                    @if (selectedTabType === hypeTabTypeEnum.primary && !config.linkHref && config.linkText) {
                        <agpr-button
                            id="agpr_hype_tabToggle_primaryLink"
                            [label]="config.linkText"
                            [disabled]="disableLink"
                            (click)="clickLink()"
                            [style]="buttonTypes.tertiary"
                            class="agpr-hypePage-tabPrimaryLink"
                        ></agpr-button>
                    }
                } @else {
                    <agpr-agent-banner
                        class="agpr-hypePage-agentBanner"
                        [id]="id"
                        [headerTitle]="config?.naturalLanguageBannerTitle | localize"
                        [submitTooltip]="config?.naturalLanguageSubmitTooltip"
                        [submitTooltipEmpty]="config?.naturalLanguageSubmitTooltipEmpty"
                        [showExpandButton]="false"
                        [hasAgentDebug]="hasAgentDebug"
                        [(naturalLanguagePrompt)]="naturalLanguagePrompt"
                        [(taskDescription)]="taskDescription"
                        [(systemPrompt)]="systemPrompt"
                        [(topicSystemPrompt)]="topicSystemPrompt"
                        (submit)="showContextTakeover($event)"
                    ></agpr-agent-banner>
                    @if (!config.linkHref && config.linkText) {
                        <agpr-button
                            id="hype-button"
                            [label]="config.linkText"
                            [disabled]="disableLink"
                            (click)="clickLink()"
                            [style]="buttonTypes.tertiary"
                            [ngClass]="{ 'agpr-hypePage-link--disabled': disableLink }"
                        >
                        </agpr-button>
                    }
                }
            </div>
        } @else if (!config.multiColumns) {
            @if (config.isNotFound) {
                <agpr-message
                    class="agpr-hypePage-message"
                    [icon]="'fa-duotone fa-regular fa-file-xmark'"
                    [severity]="messageSeverityEnum.noContent"
                    >
                    <span class="agpr-hypePage-message-header">{{ config.headingText | localize }}</span>
                    {{ config.line1Text | localize }}
                </agpr-message>
            }
            @if (!config.isNotFound) {
                <div class="agpr-hypePage-content">
                    @if (!!config.icon) {
                        <div
                            class="agpr-hypePage-logo"
                            [ngClass]="config.icon"
                            aria-hidden="true"
                        ></div>
                    }
                    @if (!!config.iconUrl) {
                        <div>
                            <img
                                [src]="config.iconUrl"
                                alt=""
                                aria-hidden="true"
                            >
                        </div>
                    }
                    <div class="agpr-hypePage-headerTitle">
                        {{ config.headingText | localize }}
                    </div>
                    @if (!!config.line1Text) {
                        <div class="agpr-hypePage-text">
                            {{ config.line1Text | localize }}
                        </div>
                    }
                    @if (!!config.line1Html) {
                        <div
                            class="agpr-hypePage-text"
                            [innerHTML]="config.line1Html"
                        >
                        </div>
                    }
                    <div
                        class="agpr-hypePage-text line2"
                        [ngClass]="{ 'agpr-hypePage-text--bold': config.line2Bold }"
                    >
                        {{ config.line2Text | localize }}
                        @if (config.linkHref) {
                            <a
                                id="hype-link"
                                class="agpr-hypePage-link"
                                [ngClass]="{ 'agpr-hypePage-link--disabled': disableLink }"
                                (click)="clickLink()"
                                [href]="config.linkHref | localize"
                                target="_blank"
                            >{{config.linkText | localize}}</a> <!-- Seperating this into multiple lines adds extra whitespace in link -->
                        }
                    </div>
                    @if (!config.linkHref && config.linkText) {
                        <agpr-button
                            id="hype-button"
                            [label]="config.linkText"
                            [icon]="config.hideButtonIcon ? '' : 'fa-regular fa-duotone fa-square-plus'"
                            [disabled]="disableLink"
                            (click)="clickLink()"
                            [style]="buttonTypes.primary"
                            [ngClass]="{ 'agpr-hypePage-link--disabled': disableLink }"
                        >
                        </agpr-button>
                    }
                </div>
            }
        } @else {
            <div class="agpr-hypePage-content">
                <div
                    class="agpr-hypePage-logo"
                    [ngClass]="config.icon"
                    aria-hidden="true"
                ></div>
                <div class="agpr-hypePage-headerTitle">
                    {{ config.headingText | localize }}
                </div>
                @if (!!config.line1Text) {
                    <div class="agpr-hypePage-text">
                        {{ config.line1Text | localize }}
                    </div>
                }
                <div
                    class="agpr-hypePage-text line2"
                    [ngClass]="{ 'agpr-hypePage-text--bold': config.line2Bold }"
                >
                    {{ config.line2Text | localize }}
                </div>

                <div class="agpr-hypePage-multiColumn">
                    <div class="agpr-hypePage-multiColumn-section">
                        <div class="agpr-hypePage-multiColumn-headerContainer">
                            <div
                                class="agpr-hypePage-multiColumn-logo"
                                [ngClass]="config.firstIcon"
                                aria-hidden="true"
                            ></div>
                            <div class="agpr-hypePage-multiColumn-headerTitle">
                                {{ config.firstHeadingText | localize }}
                            </div>
                        </div>
                        <div class="agpr-hypePage-multiColumn-text">
                            {{ config.firstLineText | localize }}
                        </div>
                        <div class="agpr-hypePage-multiColumn-spacer"></div>
                        <agpr-button
                            id="hype.firstButton"
                            [label]="config.firstLinkText"
                            [icon]="config.hideButtonIcon ? '' : 'fa-regular fa-duotone fa-square-plus'"
                            [disabled]="disableLink"
                            (click)="clickLink()"
                            [style]="buttonTypes.primary"
                            [ngClass]="{ 'agpr-hypePage-link--disabled': disableLink }"
                        >
                        </agpr-button>
                    </div>
                    <div class="agpr-hypePage-multiColumn-section">
                        <div class="agpr-hypePage-multiColumn-headerContainer">
                            <div
                                class="agpr-hypePage-multiColumn-logo"
                                [ngClass]="config.secondaryIcon"
                                aria-hidden="true"
                            ></div>
                            <div class="agpr-hypePage-multiColumn-headerTitle">
                                {{ config.secondaryHeadingText | localize }}
                            </div>
                        </div>
                        <div class="agpr-hypePage-multiColumn-text">
                            {{ config.secondaryLineText | localize }}
                        </div>
                        <div class="agpr-hypePage-multiColumn-spacer"></div>
                        <agpr-button
                            id="hype.secondButton"
                            [label]="config.secondaryLinkText"
                            [icon]="config.hideButtonIcon ? '' : 'fa-regular fa-duotone fa-square-plus'"
                            [disabled]="disableLink"
                            (click)="clickSecondaryLink()"
                            [style]="buttonTypes.primary"
                            [ngClass]="{ 'agpr-hypePage-link--disabled': disableLink }"
                        >
                        </agpr-button>
                    </div>
                </div>
            </div>
        }

        @if (showImage && !config.isNotFound) {
            <img
                class="agpr-hypePage-image"
                [src]="imgUrl"
                alt=""
            />
        }
    </main>
}
